class ContentRowSlider extends HTMLElement {
  constructor() {
    super();
    this.embla = null;
    this.progressBar = null;
    this.autoplayDuration = 5000; // 4 seconds - adjust this value if needed
    this.autoplayRequestId = null;
    this.isPlaying = false;
  }

  connectedCallback() {
    this.initEmbla();
  }

  initEmbla() {
    const emblaNode = this.querySelector('.embla');
    const options = { loop: true };

    if (emblaNode) {
      this.embla = EmblaCarousel(emblaNode, options);
      this.setupProgressBar();
      this.setupAutoplay();
    }
  }

  setupProgressBar() {
    this.progressBar = this.querySelector('.embla__progress');
  }

  setupAutoplay() {
    this.startAutoplay();
  }

  startAutoplay() {
    this.isPlaying = true;

    this.autoplayStartTime = performance.now();
    this.resetProgressBar();
    this.scheduleNextSlide();
  }

  stopAutoplay() {
    this.isPlaying = false;
    if (this.autoplayRequestId) {
      cancelAnimationFrame(this.autoplayRequestId);
      this.autoplayRequestId = null;
    }
    this.progressBar.style.transition = 'none';
    this.progressBar.style.transform = 'translateX(-100%)';
  }

  scheduleNextSlide() {
    if (!this.isPlaying) return;

    const elapsedTime = performance.now() - this.autoplayStartTime;
    const remainingTime = Math.max(0, this.autoplayDuration - elapsedTime);

    this.autoplayRequestId = setTimeout(() => {
      if (this.embla.canScrollNext()) {
        this.embla.scrollNext();
      } else {
        this.embla.scrollTo(0);
      }
      this.autoplayStartTime = performance.now();
      this.resetProgressBar();
      this.scheduleNextSlide();
    }, remainingTime);
  }

  resetProgressBar() {
    this.progressBar.style.transition = 'none';
    this.progressBar.style.transform = 'translateX(-100%)';

    // Force a reflow
    this.progressBar.offsetHeight;

    this.progressBar.style.transition = `transform ${this.autoplayDuration}ms linear`;
    this.progressBar.style.transform = 'translateX(0%)';
  }
}

customElements.define('content-row-slider', ContentRowSlider);
